import styles from './styles';

interface VehicleCardBadgeProps {
  badgeText: string;
  badgeClass?: string;
}

export default function VehicleCardBadge({
  badgeText,
  badgeClass,
}: VehicleCardBadgeProps): JSX.Element {
  return (
    <div className={`vehicle-card-badge ${badgeClass}`}>
      {badgeText}
      <style jsx>{styles}</style>
    </div>
  );
}
